import React from 'react';
import { calculateFinalPrice } from './costSheetUtils';

const CostSheetResult = ({ formData, calculatedValues, exchangeRate, onCompare }) => {
  const finalPrice = calculateFinalPrice({
    inputCost: formData.inputCost,
    shippingCost: calculatedValues.shippingCost,
    interestAmount: calculatedValues.interestAmount,
    margin: formData.margin,
    exchangeRate: exchangeRate,
    currency: formData.currency
  });

  // Calculate breakdown
  const costInAED = formData.currency !== 'AED' 
    ? parseFloat(formData.inputCost) * exchangeRate 
    : parseFloat(formData.inputCost);
  
  const totalCost = costInAED + calculatedValues.shippingCost + calculatedValues.interestAmount;
  const marginAmount = finalPrice - totalCost;

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 border-2 border-gray-200">
      <h2 className="text-xl font-semibold mb-6">Calculation Results</h2>
      
      <div className="space-y-4 mb-6">
        <div className="flex justify-between items-center pb-2 border-b">
          <span className="text-gray-600">Input Cost ({formData.currency})</span>
          <span className="font-medium">
            {parseFloat(formData.inputCost).toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })} {formData.currency}
          </span>
        </div>

        <div className="flex justify-between items-center pb-2 border-b">
          <span className="text-gray-600">Input Cost (AED)</span>
          <span className="font-medium">
            {costInAED.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })} AED
          </span>
        </div>

        <div className="flex justify-between items-center pb-2 border-b">
          <span className="text-gray-600">Shipping Cost</span>
          <span className="font-medium">
            {calculatedValues.shippingCost.toFixed(2)} AED
          </span>
        </div>

        {calculatedValues.interestAmount > 0 && (
          <div className="flex justify-between items-center pb-2 border-b">
            <span className="text-gray-600">Interest ({calculatedValues.interestDays} days)</span>
            <span className="font-medium">
              {calculatedValues.interestAmount.toFixed(2)} AED
            </span>
          </div>
        )}

        <div className="flex justify-between items-center pb-2 border-b">
          <span className="text-gray-600">Total Cost</span>
          <span className="font-medium">
            {totalCost.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })} AED
          </span>
        </div>

        <div className="flex justify-between items-center pb-2 border-b">
          <span className="text-gray-600">Margin ({formData.margin}%)</span>
          <span className="font-medium">
            {marginAmount.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })} AED
          </span>
        </div>
      </div>

      <div className="bg-black text-white rounded-lg p-6 mb-4">
        <div className="flex justify-between items-center">
          <div>
            <div className="text-sm text-gray-300 mb-1">Final Quote Price</div>
            <div className="text-3xl font-bold">
              {finalPrice.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })} AED
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={onCompare}
        className="w-full bg-gray-800 text-white px-6 py-3 rounded-md hover:bg-gray-900 transition-colors font-medium flex items-center justify-center gap-2"
      >
        <span>COMPARE</span>
      </button>
    </div>
  );
};

export default CostSheetResult;

